import type { Document, TopLevelBlock, Text } from '@contentful/rich-text-types';
import { BLOCKS } from '@contentful/rich-text-types';
import type { AccordionItem } from '$quantum/molecules/Accordion';
import type { MakeContentfulRichTextRendererOptions } from '@/cms/richTextContentHelpers';
import { renderRichTextContent } from '@/cms/richTextContentHelpers';

interface SectionHeadingNode extends TopLevelBlock {
  nodeType: BLOCKS.HEADING_3;
  content: [Text];
}

const isSectionHeadingNode = (node: TopLevelBlock): node is SectionHeadingNode =>
  node.nodeType === BLOCKS.HEADING_3;

export type SectionItem = Omit<AccordionItem, 'icon'>;

/**
 * Given a list of RichText section Documents
 * transform it into titles with corresponding ReactNodes content.
 */
export const makeSectionItemsFromRichText = (
  richTexts: Document[],
  options?: MakeContentfulRichTextRendererOptions
): SectionItem[] => {
  const items: SectionItem[] = richTexts.flatMap((doc) => {
    const [headingNode] = doc.content;
    if (!isSectionHeadingNode(headingNode)) return []; // filter out sections that don't start with a heading
    const [{ value: title }] = headingNode.content;
    return {
      title,
      content: renderRichTextContent(doc, options),
    };
  });

  return items;
};
